// This file contains all project data
export const projectsData = [
    {
      title: 'Crescendo',
      slug: 'crescendo',
      date: '2025',
      summary: 'AI generated Firebase app that allows students to find music teachers for online lessons',
      description: `
        <p>As a frustrated developer with some idea of how to write JS and PHP code, I wanted to see how good AI actually was. I set myself the challenge of writing a whole Vue and Firebase app using AI for every single line of code. The result? Crescendo.</p>
        
        <p>Features include:</p>
        <ul>
          <li>Teachers can set their weekly schedule</li>
          <li>Teachers can upload free resources, and also resources that they charge for</li>
          <li>Premium content can be made available to any student, or charged for as an asset</li>
        </ul>
      `,
      featuredImage: require('@/assets/projects/crescendo/hero.png'),
      externalLink: 'https://crescendo.joshgraham.io',
      images: [
        {
          src: require('@/assets/projects/crescendo/booklesson.png'),
          caption: 'Students can book lessons according to the schedule of the tracher'
        },
        {
          src: require('@/assets/projects/crescendo/editschedule.png'),
          caption: 'Teachers can update their weekly availability'
        },
        {
          src: require('@/assets/projects/crescendo/editresources.png'),
          caption: 'Teachers can upload teaching resources to their profile that are either free or charged for'
        }
      ]
    },
    {
      title: 'Caseworker.app',
      slug: 'caseworker',
      date: '2021-2025',
      summary: 'Personally written Laravel app that allows UK elected representatives to manage casework from their constituents',
      description: `
        <p>I worked for an MP for years and I saw just how outdated the software that connects us to our representatives is. Wtih caseworker, I wanted to modernise the software that our representatives use to speak with us. Were I to pursue this further, I would try to integrate with various political party research teams.</p>
        
        <p>Features include:</p>
        <ul>
          <li>Manage emails via Microsoft Graph API</li>
          <li>Manage surgeries and calendar</li>
          <li>Tag all cases and contact constituents en masse</li>
        </ul>
      `,
      featuredImage: require('@/assets/projects/caseworker/outlook.png'),
      externalLink: 'https://caseworker.joshgraham.io',
      images: [
        {
          src: require('@/assets/projects/caseworker/outlook.png'),
          caption: 'Connect with your Outlook account and manage constituent emails in caseworker'
        },
        {
          src: require('@/assets/projects/caseworker/cases.png'),
          caption: 'Create cases from emails and keep them updated'
        },
        {
          src: require('@/assets/projects/caseworker/details.png'),
          caption: 'Update case details and add tags'
        },
        {
          src: require('@/assets/projects/caseworker/comments.png'),
          caption: 'Work with colleagues to stay up to date on developments in a case'
        },
        {
          src: require('@/assets/projects/caseworker/comms.png'),
          caption: 'Send emails and letters directly to constituents from caseworker'
        }
      ]
    },
    {
      title: 'MadeTech Voids',
      slug: 'voids-housing',
      date: '2023',
      summary: "Zero to one B2B social housing project for MadeTech's software division",
      description: `
        <p>I led the development of Voids, an innovative B2B social housing lettings system designed to streamline the process of preparing properies for relet</p>
        
        <p>My responsibilities included:</p>
        <ul>
          <li>Leading a lean team through an experimental approach to create a "zero to one" product</li>
          <li>Conducting comprehensive user research with housing officers and tenants</li>
          <li>Establishing product strategy, roadmap, and go-to-market plans</li>
          <li>Representing the product at industry conferences and hosting panel discussion webinars</li>
          <li>Overseeing the entire product lifecycle from discovery to MVP delivery</li>
        </ul>
        
        <p>The system significantly reduces administrative overhead for housing providers, and allows us to house more people more efficiently by getting losing fewer days per property to relet work.</p>
      `,
      featuredImage: require('@/assets/projects/voids-housing/hero.png'),
      externalLink: 'https://voids.madetech.com/demo',
      images: [
        {
          src: require('@/assets/projects/voids-housing/hero.png'),
          caption: 'We tested several messages for the hero section and found that the reduction in workload burden was most compelling'
        },
        {
          src: require('@/assets/projects/voids-housing/cta.png'),
          caption: 'With local councils under such financial pressure, we knew that financial saving was a huge factor in decision making.'
        },
        {
          src: require('@/assets/projects/voids-housing/props.png'),
          caption: 'This demo, using fake properties and fake jobs generated by AI, demonstrated how our scheduler worked'
        },
        {
          src: require('@/assets/projects/voids-housing/results.png'),
          caption: 'After testing, we added as slight delay to results delivery. Our results were so much better that no one believed them without "thinking" time'
        }
      ]
    }
  ];
  
  // Helper function to get project by slug
  export function getProjectBySlug(slug) {
    return projectsData.find(project => project.slug === slug) || null;
  }